<template>
<footer class="footer footer-white footer-big">
    
        <div class="container">
                        <hr/>

        <ul class="social-buttons">
            <li>
              <md-button
                href="https://twitter.com/spotlightscouts"
                target="_blank"
                class="md-twitter md-just-icon md-simple"
              >
                <i class="fab fa-twitter" />
              </md-button>
            </li>
            <li>
              <md-button
                href="https://www.instagram.com/spotlightscouts/"
                target="_blank"
                class="md-instagram md-just-icon md-simple"
              >
                <i class="fab fa-instagram" />
              </md-button>
            </li>
            <li>
              <md-button
                href="https://www.linkedin.com/company/spotlightscouts"
                target="_blank"
                class="md-linkedin md-just-icon md-simple"
              >
                <i class="fab fa-linkedin" />
              </md-button>
            </li>
          </ul>
          <div class="copyright">
            Copyright © {{ year }} Spotlight Scouts India. All Rights Reserved.
          </div>
        </div>
      </footer>
</template>

<script>
export default {
    data() {
    return {
      year: new Date().getFullYear(),
    }
    }
}
</script>